import { NgModule } from '@angular/core';
import { StartSyncButtonComponent } from './start-sync-button.component';
import { AsyncPipe, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [StartSyncButtonComponent],
  imports: [
    AsyncPipe,
    MatButtonModule,
    NgIf,
  ],
  exports: [
    StartSyncButtonComponent,
  ],
})
export class StartSyncButtonModule {}
